import {
  ChangeDetectionStrategy,
  Component, ElementRef,
  inject, input, signal,
} from '@angular/core';
import { lsapIconColor } from '@models/lsap-icon-color.model';
import { TooltipModule } from 'primeng/tooltip';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-ui-btn',
  standalone: true,
  imports: [
    TooltipModule,
    NgClass,
  ],
  host: {
    '(click)': 'onClick($event)',
  },
  templateUrl: './ui-btn.component.html',
  styleUrl: './ui-btn.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiBtnComponent {
  onClick(event: MouseEvent) {
    if (this.disabled)
      return;
    const button = this.elRef.nativeElement.querySelector('button');
    let startTime: number;

    requestAnimationFrame(drawRipple);

    const rect = button.getBoundingClientRect();
    const startX = event.clientX - rect.left;
    const startY = event.clientY - rect.top;

    function drawRipple(timestamp: number) {
      if (!startTime) startTime = timestamp;
      const progress = (timestamp - startTime) / 300;

      if (progress < 1) {
        const gradientPosition = `${startX}px ${startY}px`;
        const maxDim = Math.max(rect.width, rect.height) * 2;
        const gradientSize = `${progress * maxDim}px`;

        button.style.backgroundImage = `radial-gradient(circle ${gradientSize} at ${gradientPosition}, rgba(255,255,255, ${0.5 - progress * 0.5}), transparent 100%)`;

        requestAnimationFrame(drawRipple);
      } else {
        button.style.backgroundImage = '';
      }
    }
  }

  size = input<'small' | 'medium' | 'large'>('medium');
  color = input<lsapIconColor>('transparent');
  btnType = input<'text' | 'circle' | 'square'>('text');
  outline = input(false);
  tooltip = input<string>();
  icon = input<string>();
  iconColor = input<lsapIconColor>();
  iconSize = input<'icon-small' | 'icon-large'>('icon-small');
  disabled = input(false);
  animation = input<'rotate'>();
  active = input(false);

  private readonly elRef = inject(ElementRef);

  rotate = signal(false);

  animate() {
    if (this.animation() === 'rotate')
      this.rotateBtn();
  }

  rotateBtn() {
    this.rotate.set(true);

    setTimeout(() => {
      this.rotate.set(false);
    }, 250);
  }
}
